import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import './css/impressao.css';
import API from '../../../actions/api-helper';
import UI from '../../../actions/ui-helper';
import DataUtil from '../../../actions/data.js';

class ImpressaoApuracao extends Component {
  constructor(props) {
    super(props);
    this.state = false;
    if (this.props.location) {
      this.state = this.props.location.state;
    }
  }

  componentDidMount() {
    if (!this.state) return;
    UI.loader('show', 'Aguarde, gerando relatório...');
    API.post('/apuracao', this.state)
      .then(
        function(json) {
          this.setState(json.data);
          UI.loader('hide');
        }.bind(this),
      )
      .catch(function(json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state) {
      this.props.history.push('/apuracao');
      return false;
    }
    if (!this.state.codigos) {
      return false;
    }

    let codigoStyle = { width: '20%' };
    let nomeStyle = { textAlign: 'center' };
    let valorStyle = { textAlign: 'right' };

    // Configurações do relatório
    let usuariosPorLinha = 4;
    let totalUsuarios = this.state.codigos[0].usuarios.length;
    let totalLinhas = totalUsuarios / usuariosPorLinha;
    let linhas = [];
    for (var i = 0; i < totalLinhas; i++) {
      let start = i * usuariosPorLinha;
      let end = start + (usuariosPorLinha - 1);
      end = end + 1 > totalUsuarios ? totalUsuarios : end;

      linhas.push(
        <div key={i} className="report-content">
          <table className="report-table stretch">
            <thead>
              <tr>
                <th style={codigoStyle}>Código</th>
                {this.state.formato === 1 && <th>Unidade</th>}
                {this.state.codigos[0].usuarios.map(function(usuario, index) {
                  if (index >= start && index <= end)
                    return (
                      <th key={index} style={nomeStyle} colSpan="2">
                        {usuario.nome}
                      </th>
                    );
                  return null;
                })}
              </tr>
            </thead>
            <tbody>
              {this.state.codigos.map(
                function(procedimento, index) {
                  return (
                    <tr key={index}>
                      <td>{procedimento.codigo}</td>
                      {this.state.formato === 1 && (
                        <td>{procedimento.unidade === 1 ? 'Horas' : 'Procedim.'}</td>
                      )}
                      {procedimento.usuarios.map(
                        function(usuario, index) {
                          if (index >= start && index <= end)
                            return [
                              <td key={'u' + index} style={valorStyle}>
                                {usuario.quantidade > 0 &&
                                  ((this.state.formato === 1
                                    ? procedimento.unidade
                                    : usuario.unidade) <= 1
                                    ? DataUtil.formatarHora(usuario.minutos)
                                    : usuario.quantidade)}
                              </td>,
                              <td key={'v' + index} style={valorStyle}>
                                R$ {usuario.total.toFixed(2).replace('.', ',')}
                              </td>,
                            ];
                        }.bind(this),
                      )}
                    </tr>
                  );
                }.bind(this),
              )}
            </tbody>
          </table>
          <br />
        </div>,
      );
    }

    // Dados do cabeçalho
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;

    // Renderização da tabela
    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}>
          <i className="icon icon-printer" />
          Preparar para Impressão
        </button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
          <h4>
            {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep} -{' '}
            {endereco.cidade} - {endereco.estado}
          </h4>
          <h3>
            {this.state.formato === 1 ? 'APURAÇÃO DE RESULTADO' : 'RELATÓRIO DE PRODUÇÃO'} -{' '}
            {this.state.periodoDe} - {this.state.periodoAte}
          </h3>
        </header>
        <hr />
        {linhas.map(function(linha) {
          return linha;
        })}
        <footer className="report-footer">
          <span id="pageCount" />
        </footer>
      </div>
    );
  }
}

export default withRouter(ImpressaoApuracao);
